import { ref, onMounted, watch } from 'vue';
import http from '@/http.js';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function useAfficherRequete(props) {
    const locale = ref("fr-FR");
    const idRequete = ref('');
    const idUtilisateur = ref('');
    const schema = ref({});
    const schemas = ref([]);
    const titre = ref('');
    const type = ref('');
    const description = ref('');
    const sql = ref('');
    const gravite = ref('');
    const tables = ref('');
    const message = ref('');
    const keywords = ref('');
    const champAnomalique = ref('');
    const optionType = ref([
        { value: "1", text: "requête" },
        { value: "2", text: "script php" },
    ]);
    const optionGravite = ref([
        { value: "1", text: "Bloquant" },
        { value: "2", text: "Majeur" },
        { value: "3", text: "Mineur" },
    ]);
    const parametres = ref([]);

    const fetchSchemas = async () => {
        const data = await http.getSchema();
        schemas.value = data;
    };

    const loadRequete = async (id) => {
        const data = await http.loadRequete(id);
        idRequete.value = data.idRequete;
        titre.value = data.titre;
        description.value = data.description;
        schema.value = data.schema;
        type.value = data.type;
        sql.value = data.sql;
        champAnomalique.value = data.champAnomalique;
        keywords.value = data.keywords;
        gravite.value = data.gravite;
        message.value = data.message;
        tables.value = data.tables;
        parametres.value = data.parametres;
    };

    onMounted(() => {
        fetchSchemas();
        if (props.id !== undefined) {
            loadRequete(props.id);
        }
    });

    watch(() => props.id, (newId) => {
        if (newId !== undefined) {
            loadRequete(newId);
        }
    });

    return {
        locale,
        idRequete,
        idUtilisateur,
        schema,
        schemas,
        titre,
        type,
        description,
        sql,
        gravite,
        tables,
        message,
        keywords,
        champAnomalique,
        optionType,
        optionGravite,
        parametres,
        fetchSchemas,
        loadRequete,
    };
}